module.exports = __webpack_public_path__ + "img/notification-circle.ef536458.svg";